import { Shade } from '@/general/components/Shade/Shade';
import clsx from 'clsx';
import { FC, ReactNode } from 'react';

type Props = {
  icon: ReactNode;
  title: string;
  label?: string;
  reverseLabel?: boolean;
  onClick: () => void;
  dataTestId?: string;
};

export const CarHeroButton: FC<Props> = ({ icon, title, label, reverseLabel, onClick, dataTestId }) => (
  <button
    className="c-shade_container relative h-10 min-w-10 cursor-pointer overflow-hidden rounded-sm bg-tex-inv-tie2 p-2 transition-colors duration-200 hover:bg-for-pri-lig focus:bg-tex-inv-tie2"
    title={title}
    onClick={onClick}
    data-testid={dataTestId}
  >
    <Shade noBackground />
    <span
      className={clsx('flex items-center', {
        ['flex-row-reverse']: reverseLabel,
      })}
    >
      {icon}
      {label && <span className="c-fs-body2 hidden px-2 font-semibold sm:block">{label}</span>}
    </span>
  </button>
);
